import $http from '../../../axios-instance';
import Swal from 'sweetalert2'

export async function createSection({ commit, state, rootState }, data) {
    commit('dashboard/load', true, { root: true });
    try {
        const response = await $http.post('/inventory-sections/create', data);

        Swal.fire({
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500
        })
        commit('dashboard/load', false, { root: true });
    } catch (error) {
        let msg = 'Error al crear la seccion'
        if (error.errors.name[0]) {
            msg = error.errors.name[0]
        }

        Swal.fire({
            icon: 'error',
            title: msg,
            showConfirmButton: false,
            timer: 1500
        })
        commit('dashboard/load', false, { root: true });
    }

}

//Lista de secciones
export async function getSections({ commit, state, rootState },data) {
    commit('dashboard/load', true, { root: true });
    try {
        const response = await $http.get('/inventory-sections/list?perPage=' + data.perPage + '&page=' + data.page + '&search=' + data.search);
        commit('dashboard/load', false, { root: true });
        return response.data.data;
    } catch (error) {
        commit('dashboard/load', false, { root: true });
        return [];
    }
}

//Obtener seccion por id
export async function getSectionById({ commit, state, rootState }, id) {
    commit('dashboard/load', true, { root: true });
    try {
        const response = await $http.get('/inventory-sections/' + id);
        commit('dashboard/load', false, { root: true });
        return response.data.data;
    } catch (error) {
        commit('dashboard/load', false, { root: true });
        return [];
    }
}

//Actualizar seccion
export async function updateSection({ commit, state, rootState }, data) {
    commit('dashboard/load', true, { root: true });
    try {
        const response = await $http.put('/inventory-sections/'+data.id, data);
        Swal.fire({
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500
        })
        commit('dashboard/load', false, { root: true });
    } catch (error) {
        let msg = 'Error al actualizar la seccion'
        if (error.errors.name[0]) {
            msg = error.errors.name[0]
        }

        Swal.fire({
            icon: 'error',
            title: msg,
            showConfirmButton: false,
            timer: 1500
        })
        commit('dashboard/load', false, { root: true });
    }
}

//Listar todas las secciones
export async function listAllSections({ commit, state, rootState }) {
    commit('dashboard/load', true, { root: true });
    try {
        const response = await $http.get('/inventory-sections/all');
        commit('dashboard/load', false, { root: true });
        return response.data.data;
    } catch (error) {
        commit('dashboard/load', false, { root: true });
        return [];
    }
}
